/*! GBI collection page-size control — uses ?view=pp-36 / pp-48 alternate templates */
(function () {
  function setPageSize(size) {
    var url = new URL(window.location.href);
    var n = String(size);
    if (n === '24') {
      url.searchParams.delete('view');
    } else {
      url.searchParams.set('view', 'pp-' + n);
    }
    url.searchParams.delete('page');
    window.location.assign(url.pathname + url.search + url.hash);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-gbi-page-size]');
    if (!btn) return;
    event.preventDefault();
    setPageSize(btn.getAttribute('data-gbi-page-size'));
  });
})();
